<title>{{ ndcSupportFaqPage.htmlTitle }}</title>
<app-banner [banner]="ndcSupportFaqPage.banner"></app-banner>
<div class="container faq-disruption-notifications faqpages">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [isInnerBorder]="true" [sections]="ndcSupportFaqPage.sections"></app-border-section>
</div>
